export type Network = "ETH" | "TRX";
export type Status = "ALLOWED" | "FORBIDDEN";

export interface WalletsWhitelistType {
  id: string;
  destinationWallet: string;
  network: Network;
  status: Status;
  usedCount: number;
  createdAt: string;
  createdByName: string;
  statusDate: string | null;
  companyName: string;
  companyInn: string;
  companyOgrn: string;
}

export enum WALLETS_WHITELIST_STATUS {
  ALLOWED = "ALLOWED",
  FORBIDDEN = "FORBIDDEN",
}

export const WALLETS_WHITELIST_STATUS_TEXT: Record<WALLETS_WHITELIST_STATUS, string> = {
  ALLOWED: "Разрешён",
  FORBIDDEN: "Запрещён",
};

export const WALLETS_WHITELIST_STATUS_BUTTON_TEXT: Record<WALLETS_WHITELIST_STATUS, string> = {
  ALLOWED: "Запретить",
  FORBIDDEN: "Разрешить",
};

export const WALLETS_WHITELIST_STATUS_COLORS: Record<WALLETS_WHITELIST_STATUS, string> = {
  ALLOWED: "green",
  FORBIDDEN: "red",
};

export enum WALLETS_WHITELIST_NETWORK_FILTERS {
  ETH = "ETH",
  TRX = "TRX",
}
